/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The possible pagination direction types.
 * @export
 */
export type PaginationDirectionType = PaginationDirectionTypeAfter | PaginationDirectionTypeBefore;

/**
 * The after pagination direction type.
 * @export
 */
export type PaginationDirectionTypeAfter = typeof PAGINATION_DIRECTION_TYPE_AFTER;

/**
 * The before pagination direction type.
 * @export
 */
export type PaginationDirectionTypeBefore = typeof PAGINATION_DIRECTION_TYPE_BEFORE;

/**
 * The after pagination direction constant.
 * @export
 */
export const PAGINATION_DIRECTION_TYPE_AFTER = `after`;

/**
 * The before pagination direction constant.
 * @export
 */
export const PAGINATION_DIRECTION_TYPE_BEFORE = `before`;

/**
 * The pagination page limit options.
 * @export
 */
export enum PaginationPageLimit {
  tiny = 5,
  small = 20,
  medium = 50,
  large = 100,
}
